import * as React from 'react'
import { SbEditableBlok } from '@storyblok/storyblok-editable'
import { useReccuringModule } from '../../lib/hooks/useReccuringModule'
import { DynamicComponent } from '../../components/DynamicComponent'
import { useContactFormData } from '../../lib/hooks/useContactFormData'

export const RecurringModule = ({ blok }: SbEditableBlok) => {
  const module = useReccuringModule(blok?.relation)

  if (module?.field_component === 'ContactPanel') {
    module.content = useContactFormData(module.uuid)
  }

  if (!module?.content) {
    return null
  }

  const recurringModuleTheme = blok?.themeColor || null
  const recurringReferenceTheme = module?.content?.theme || null
  const theme = recurringModuleTheme || recurringReferenceTheme

  return <DynamicComponent blok={{ ...module.content, theme: theme }} />
}
